import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Size Master'}
      url={'size-master'}
      queryKey="size-master"
      title={'Size Master'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
